import {Spin} from "antd";

const Loading = ({...props}) => <Spin {...props} />

export default Loading;
